<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Permiso
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="segments"
          :subtitle="subtitle"
          :heightCard="heightCard"
          :openDialog="openDialog"
          @goToItem="goToElement"
          :title="title"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="segments"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          :goToItem="goToElement"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
    </v-col>
    <v-dialog
      v-model="openSegment"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <FormOrder
        :allFields="parameters.items"
        @save="saveForm"
        @cancel="reset"
        :mode="mode"
        :show="true"
        :itemsSlider="dataSegmentSlider"
        @itemUpdate="updateDataSelect"
        @changeSlider="changeSlider"
      >
      </FormOrder>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import FormOrder from "../../Complement/FormOrder.vue";
export default {
  components: {
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    FormOrder,
    DeleteDialog,
    Snackbar,
  },

  data() {
    return {
      showCard: true,
      title: "Segmentos",
      titleTable: "PermisosDeAcceso_Segmentos",
      subtitle: "Número de secuencia: ",
      color: "",
      titleDelete: this.$tc("schedules.toSegment"),
      itemInfo: null,
      itemsRequired: [
        { id: 0, name: "No" },
        { id: 1, name: "Si" },
        { id: 2, name: "No definido" },
      ],
      headers: [
        {
          text: "Segmento",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Número de secuencia",
          value: "sequenceNumber",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Días",
          value: "days",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desp. de Jornada",
          value: "despl",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo de jornada",
          value: "typeJor",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require Cacheo",
          value: "requiredCacheoIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Porcentaje Cacheo",
          value: "porcentCacheo",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Require Pin",
          value: "requiredPinIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require PassBack",
          value: "requiredPassBackIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataSegmentSlider: [
        {
          name: "desplJor",
          label: "Desplazamiento de jornada",
          data: 0,
          type: "text",
          max: 720,
          min: -720,
          tooltip: this.$tc("schedules.alertDesp"),
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],
      dataSegment: [
        {
          name: "name",
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
        {
          name: "days",
          label: "Días",
          data: null,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 365) || this.$tc("schedules.rulesDataSegment"),
          ],
        },
        {
          name: "sequence",
          label: "Secuencia",
          data: null,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 1000) ||
              this.$tc("schedules.rulesSegmentSequence"),
          ],
        },
        {
          name: "porcentCacheo",
          label: "Porcentaje Cacheo",
          data: 0,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 1000) ||
              this.$tc("schedules.rulesSegmentSequence"),
          ],
        },
      ],

      maxWidth: "600px",
      heightCard: "180px",
      dataSelected: [
        {
          name: "jor",
          label: this.$tc("schedules.typeJor"),
          data: 0,
          items: [
            { id: 0, name: "Extendida" },
            { id: 1, name: "Dividida" },
            { id: 2, name: "Truncada" },
          ],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "reqPassBack",
          label: "Require PassBack",
          data: 2,
          items: [
            { id: 0, name: "No" },
            { id: 1, name: "Si" },
            { id: 2, name: "No definido" },
          ],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "reqPin",
          label: "Require Pin",
          data: 2,
          items: [
            { id: 0, name: "No" },
            { id: 1, name: "Si" },
            { id: 2, name: "No definido" },
          ],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "reqCacheo",
          label: "Require Cacheo",
          data: 2,
          items: [
            { id: 0, name: "No" },
            { id: 1, name: "Si" },
            { id: 2, name: "No definido" },
          ],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ],
      typeForm: "",
      slider: { desplJor: 0 },
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
    };
  },

  computed: {
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "name",
            type: "text",
            label: this.$tc("accessPermision.nameSegment"),
            items: [],
            itemText: "name",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "days",
            type: "text",
            label: "Días",
            items: [],
            itemText: "days",
            itemText: "days",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },

          {
            id: 3,
            show: true,
            data: "",
            name: "sequence",
            type: "text",
            label: "Secuencia",
            items: [],
            itemText: "sequence",
            itemText: "sequence",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 3,
          },
          {
            id: 4,
            show: true,
            data: 0,
            name: "jor",
            type: "select",
            label: this.$tc("schedules.typeJor"),
            items: [
              { id: 0, name: "Extendida" },
              { id: 1, name: "Dividida" },
              { id: 2, name: "Truncada" },
            ],
            itemValue: "id",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 4,
          },
          {
            id: 5,
            show: true,
            data: 2,
            name: "reqCacheo",
            type: "select",
            label: this.$tc("accessPermision.requiredCacheo"),
            items: this.itemsRequired,
            itemValue: "id",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 5,
          },
          {
            id: 6,
            show: true,
            disabled: true,
            data: "",
            name: "porcenCacheo",
            type: "text",
            label: this.$tc("accessPermision.porcentCacheo"),
            items: this.itemsRequired,
            itemText: "name",
            itemText: "name",
            rules: [],
            order: 6,
          },
          {
            id: 7,
            show: true,
            data: 2,
            name: "reqPin",
            type: "select",
            label: this.$tc("accessPermision.requiredPin"),
            items: this.itemsRequired,
            itemValue: "id",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 7,
          },
          {
            id: 8,
            show: true,
            data: 2,
            name: "reqPassBack",
            type: "select",
            label: this.$tc("accessPermision.requiredPassBack"),
            items: this.itemsRequired,
            itemValue: "id",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 8,
          },
        ],
      };
    },
    allHeaders() {
      return configTable.state.colums;
    },
    segments() {
      return schedules.state.segments;
    },
    segment() {
      return schedules.state.segments.map((segment) => {
        const elements = segment.elements?.map((element) => element.name);
        const sequence = segment.sequenceNumber;
        return {
          ...segment,
          chips: elements,
          subtitle: sequence,
        };
      });
    },

    padding() {
      return schedules.state.paddingNav;
    },
    openSegment: {
      get() {
        return schedules.state.openSegment.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return schedules.state.openDeleteSeg;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  methods: {
    async refreshItems() {
      await schedules.dispatch("getSegments");
    },
    updateDataSelect(item) {
      if (item.name === "reqCacheo" && item.data == 1) {
        this.parameters.items.find(
          (item) => item.name === "porcenCacheo"
        ).disabled = false;
      } else if (item.name === "reqCacheo" && item.data !== 1) {
        this.parameters.items[5].data = "0";
        this.parameters.items.find(
          (item) => item.name === "porcenCacheo"
        ).disabled = true;
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm(items) {
      const type = schedules.state.openSegment;
      let payload = {
        ...items,
        ...this.slider,
        permissionId: schedules.state.permissionId,
        porcenCacheo: items.porcenCacheo !== undefined ? items.porcenCacheo : 0,
      };

      if (type.type == "tree") {
        this.addSegment(payload);
      }

      switch (this.typeForm) {
        case "add":
          this.addSegment(payload);
          break;
        case "edit":
          this.editSegment(payload);
          break;
        default:
          break;
      }
    },
    changeSlider(item) {
      this.slider = item;
    },
    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },
    reset(value) {
      if (this.typeForm !== "delete") {
        schedules.commit("setOpenSegment", value);
        this.dataSelected.forEach((item) => {
          item.data = 0;
        });
        this.dataSegment.forEach((item) => {
          if (item.name == "name") {
            item.data = "";
          } else {
            item.data = null;
          }
        });
        this.dataSegmentSlider.forEach((item) => {
          item.data = 0;
        });

        this.slider = { desplJor: 0 };
      }

      this.alert = false;
    },
    openDialog(type, item, event) {
      this.typeForm = type;
      let payload = {
        type: "card",
        value: true,
      };
      switch (this.typeForm) {
        case "add":
          schedules.commit("setMode", this.$tc("schedules.addSegment"));
          schedules.commit("setOpenSegment", payload);
          break;
        case "edit":
          this.itemInfo = item.elements;
          schedules.commit("setMode", this.$tc("schedules.editSegment"));
          this.parameters.items[0].data = item.name;
          this.parameters.items[1].data = item.days;
          this.parameters.items[2].data = item.numberSequence;
          this.parameters.items[3].data = item.typeShift;
          this.parameters.items[4].data = item.requiredCacheo;

          this.parameters.items[5].disabled = !(item.requiredCacheo === 1);
          this.parameters.items[5].data = item.porcentCacheo;
          this.parameters.items[6].data = item.requiredPin;
          this.parameters.items[7].data = item.requiredPassBack;
          this.dataSegmentSlider[0].data = item.shiftTravel;
          this.itemId = item.id;
          schedules.commit("setOpenSegment", payload);

          break;
        case "delete":
          if (event) {
            event.stopPropagation();
          }
          schedules.commit("setOpenDeleteSeg", true);
          this.itemToDelete = item.id;

          break;

        default:
          break;
      }
    },

    goToElement(item) {
      schedules.commit("setSegmentId", item.id);
      schedules.dispatch("handleShowWindow", "element");
    },
    cardView(value) {
      this.showCard = value;
    },
    addSegment(items) {
      schedules.commit("setNewSegment", items);
      schedules
        .dispatch("newSegment")
        .then(() => {
          schedules.commit("setOpenSegment", false);
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addSegmentAlert");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    editSegment(items) {
      let payload = {
        ...items,
        segmId: this.itemId,
      };

      payload.elements = this.itemInfo;

      schedules.commit("setEditSegment", payload);
      schedules
        .dispatch("editSegment")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.editSegmentAlert");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    deleteItem() {
      schedules.commit("setItemDelete", this.itemToDelete);
      schedules
        .dispatch("deleteSegment")
        .then(() => {
          this.openDelete = false;
          schedules.commit("setOpenDeleteSeg", false);
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.deleteSegment");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.cancelDelete();
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteSeg", false);
    },
  },
};
</script>
<style scoped></style>
